import { IamData } from '../types/user.types';

export type UserAccountStatus = 'invited' | 'active' | 'deactivated';

export const USER_ACCOUNT_STATUS_OPTIONS: { value: UserAccountStatus; label: string }[] = [
  { value: 'invited', label: 'Invited' },
  { value: 'active', label: 'Active' },
  { value: 'deactivated', label: 'Deactivated' },
];

export const getUserAccountStatus = (user: IamData): UserAccountStatus => {
  if (!user.isVarified) return 'invited';
  return user.active ? 'active' : 'deactivated';
};

export const getPrimaryRoleName = (user: IamData): string | null => user.roles?.[0] ?? null;

/** Design-reference role set (no real role-catalog endpoint exists yet). */
export const DUMMY_ROLE_OPTIONS = ['Owner', 'Admin', 'Marketer', 'Analyst'];

export const isOwnerRoleName = (roleName: string) => roleName.trim().toLowerCase() === 'owner';

export const formatLastLogin = (iso: string | null | undefined): string => {
  if (!iso) return 'Never';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime()) || date.getFullYear() <= 1) return 'Never';
  return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
};

export const getFullName = (user: IamData): string => `${user.firstName} ${user.lastName ?? ''}`.trim();
